import getTodoRequestHeaders from './getTodoRequestHeaders';
import TodoFolder, { createTodoFolder, FolderSyncStatus } from '../store/schema/TodoFolder';
import { makeGetRequest } from 'owa-ows-gateway';
import { TODO_API_GET_LISTS } from './constants';
import { userDate } from 'owa-datetime/lib/userDate';

export default function getTaskFoldersService(): Promise<TodoFolder[]> {
    return makeGetRequest(
        TODO_API_GET_LISTS,
        undefined /* correlationId */,
        false /* returnFullResponse */,
        getTodoRequestHeaders() /* customHeaders */
    )
        .then((response: any) => {
            if (response && response.Value) {
                return response.Value.map(folder => toTodoFolder(folder));
            }

            return null;
        })
        .catch(err => {
            return null;
        });
}

interface ServiceTodoFolder {
    Id: string;
    Name: string;
    IsDefaultFolder: boolean;
    IsSharedFolder: boolean;
    IsOwner: boolean;
    SyncStatus: FolderSyncStatus;
    OrderDateTime: string;
    FolderType: string;
}

function toTodoFolder(serviceFolder: ServiceTodoFolder): TodoFolder {
    const todoFolder: TodoFolder = createTodoFolder({
        ...serviceFolder,
        OrderDateTime: serviceFolder.OrderDateTime ? userDate(serviceFolder.OrderDateTime) : null,
        FolderType: 'Other',
    });

    if (
        serviceFolder.FolderType &&
        serviceFolder.FolderType.toLowerCase() === 'com.microsoft.outlook.email.commitment'
    ) {
        todoFolder.FolderType = 'Commitments';
    }

    if (
        serviceFolder.FolderType &&
        serviceFolder.FolderType.toLowerCase() === 'com.microsoft.outlook.email.flagged'
    ) {
        todoFolder.FolderType = 'FlaggedEmails';
    }

    return todoFolder;
}
